/* ============================================================
   Shop CTA Banner — behavior
   Assigns a stagger index (--i) to the heading, subheading,
   button, and each product image in DOM order, then toggles
   data-in-view on the banner every time it enters/exits the
   viewport — same replayable pattern as the Lifestyle Showcase
   section, so the reveal plays again on every scroll-in, not
   just once on page load.
   ============================================================ */
(function () {
  'use strict';

  function initBanner(banner) {
    if (banner.dataset.ctaInitialized === 'true') return;
    banner.dataset.ctaInitialized = 'true';

    if (banner.dataset.stagger !== 'true') return;

    var targets = Array.prototype.slice.call(banner.querySelectorAll('[data-cta-stagger]'));
    targets.forEach(function (el, index) {
      el.style.setProperty('--i', index);
    });

    if (!('IntersectionObserver' in window)) {
      banner.setAttribute('data-in-view', 'true');
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            requestAnimationFrame(function () {
              requestAnimationFrame(function () {
                banner.setAttribute('data-in-view', 'true');
              });
            });
          } else {
            banner.removeAttribute('data-in-view');
          }
        });
      },
      { threshold: 0.25 }
    );

    observer.observe(banner);
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-cta-banner]').forEach(initBanner);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();